let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lgiXu")).then(() => parcelRequire('jSdRm'));